import React from 'react'
import CollapsibleCheckbox from './CollapsibleCheckbox'
import CollapsibleRadio from './CollapsibleRadio'
import { AttributeLeafRow } from './attributeTreeShared'
import { getChildAttributeIds, getAttributeById } from '../../Utility/TreeUtility'

const isPlaceholder = (item) => {
  if (!item?.Details) return false
  try {
    const details = typeof item.Details === 'string' ? JSON.parse(item.Details) : item.Details
    return details.placeholder === true
  } catch {
    return false
  }
}

const AttributesSelector = ({ dimension, selection, setSelection, searchTerm, showDefinition, scrollContainerRef }) => {
  const showItem = (item) => {
    if ((item.DisplayName.toLowerCase().includes(searchTerm.toLowerCase()) || (showDefinition !== undefined && showDefinition && item.Comment.toLowerCase().includes(searchTerm.toLowerCase())))) {
      return true
    }
    return false
  }

  const dimensionId = dimension?.DimensionID ?? dimension?.dimensionId

  const checkBoxClicked = (item) => {
    if (JSON.parse(dimension.Details).singleSelect) {
      if (isPlaceholder(item)) return
      if (selection.Attributes.includes(item.AttributeID)) {
        return
      }
      setSelection(dimensionId, [item.AttributeID])
    } else if (!item.Children || item.Children.length <= 0) {
      if (isPlaceholder(item)) return
      if (selection.Attributes.includes(item.AttributeID)) {
        const updatedAttributes = selection.Attributes.filter(id => id !== item.AttributeID)
        setSelection(dimensionId, updatedAttributes)
      } else {
        setSelection(dimensionId, [...new Set([...selection.Attributes, item.AttributeID])])
      }
    } else {
      if (isPlaceholder(item)) return
      const currentItemExistsInSelection = selection.Attributes.filter(val => val === item.AttributeID)
      const allChildrens = getChildAttributeIds(item)
      if (currentItemExistsInSelection === undefined || currentItemExistsInSelection?.length < 1) {
        setSelection(dimensionId, [...new Set([...selection.Attributes, item.AttributeID])])
      } else {
        const allSelectedChildrens = selection.Attributes.filter(val => allChildrens.includes(val))
        if (allChildrens.length === allSelectedChildrens.length) {
          const updatedAttributes = selection.Attributes.filter(id => !allChildrens.includes(id))
          setSelection(dimensionId, updatedAttributes)
        } else {
          const uniqueAttributes = [...new Set([...selection.Attributes, ...allChildrens])]
          setSelection(dimensionId, uniqueAttributes)
        }
      }
    }
  }

  const isSelected = (item) => {
    if (!selection)
      return false;
    const findValue = selection?.Attributes?.find(i => i === item.AttributeID);
    return !!findValue || findValue === 0;
  }

  const details = dimension?.Details ? JSON.parse(dimension.Details) : {}
  const isSingleSelect = details.singleSelect === true
  const selectedAttributeId = isSingleSelect && selection?.Attributes?.length ? selection.Attributes[0] : null
  const selectedAttribute = selectedAttributeId != null ? getAttributeById(dimension, selectedAttributeId) : null
  const headingLabel = dimension?.DisplayName
    ? (selectedAttribute ? `${dimension.DisplayName} (${selectedAttribute.DisplayName})` : dimension.DisplayName)
    : ''

  return (
    <>
      <h1 className="dimension-heading">
        {headingLabel}
      </h1>
      <div className="dimension" ref={scrollContainerRef}>
        {
          dimension && dimension?.Attributes?.map(
            (item) =>
            (
              <div className="popup-item" key={item.AttributeID}>
                {
                  JSON.parse(dimension.Details).singleSelect
                    ? (
                        <>
                          {
                            item.Children && item.Children.length
                              ? (
                                  <CollapsibleRadio
                                    level={0}
                                    className={item.ParentAttributeID && 'child'}
                                    checked={isSelected(item)}
                                    item={item}
                                    showItem={showItem}
                                    checkBoxClicked={checkBoxClicked}
                                    showDefinition={showDefinition}
                                    selection={selection}
                                    isSelected={isSelected}
                                    searchTerm={searchTerm}
                                    isPlaceholder={isPlaceholder}
                                  />
                                )
                              : (
                                  <AttributeLeafRow
                                    item={item}
                                    showItem={showItem}
                                    showDefinition={showDefinition}
                                    isPlaceholder={isPlaceholder}
                                    checkBoxClicked={checkBoxClicked}
                                    isSelected={isSelected}
                                    variant="radio"
                                    radioClassName={item.ParentAttributeID ? 'child radio' : 'radio'}
                                  />
                                )
                          }
                        </>
                      )
                    : (
                        <>
                          {
                            item.Children && item.Children.length
                              ? (
                                  <CollapsibleCheckbox
                                    level={0}
                                    className={item.ParentAttributeID && 'child'}
                                    checked={isSelected(item)}
                                    item={item}
                                    showItem={showItem}
                                    checkBoxClicked={checkBoxClicked}
                                    showDefinition={showDefinition}
                                    selection={selection}
                                    isSelected={isSelected}
                                    searchTerm={searchTerm}
                                    isPlaceholder={isPlaceholder}
                                  />
                                )
                              : (
                                  <AttributeLeafRow
                                    item={item}
                                    showItem={showItem}
                                    showDefinition={showDefinition}
                                    isPlaceholder={isPlaceholder}
                                    checkBoxClicked={checkBoxClicked}
                                    isSelected={isSelected}
                                    variant="checkbox"
                                    checkboxClassName={item.ParentAttributeID != null && item.ParentAttributeID !== item.AttributeID ? 'child' : ''}
                                  />
                                )
                          }
                        </>
                      )
                }
              </div>
            )
          )
        }
      </div>
    </>
  )
}

export default AttributesSelector
